import { optionTitle_export_mailbox } from './ExportMailboxOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ExportMailboxOption: LazyOption = createLazyOption(
    {
        key: 'exportMailbox',
        titleStringKey: optionTitle_export_mailbox,
        searchTermsStringKey: optionTitle_export_mailbox,
        isHidden: () => !isConsumer(),
        allowedOptionKeys: ['ExportData'],
    },
    lazyFullModule,
    m => m.default
);
export default ExportMailboxOption;
